module.exports = "<div style=\"width: 40%;display: inline-block;min-width: 150px;\">\n    {{titels}} :\n    <input #myInput type=\"file\"  (change)=\"fileChange($event)\"   />\n    <img [attr.src]='file_Photo' alt=\"\" style=\"width: 100px;height: 100px;\"/>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/file-upload/file.upload.html
// module id = ./src/app/common/file-upload/file.upload.html
// module chunks = main